import ImageLayer from "./ImageLayer";
import type { ImageLoadPayload, ImagePosition } from "./types";

export type { ImagePosition, ImageLoadPayload } from "./types";

// Mirrors lambda-preprocess-images image_target_width.
const MIN_SOURCE_WIDTH = {
  medium: 2000,
  high: 4000,
} as const;

interface Props {
  imagePosition: ImagePosition;
  baseUrl: string;
  extension: string;
  sourceWidth: number | null;
  viewportWidth: number;
  viewportHeight: number;
  onLoad?: (payload: ImageLoadPayload) => void;
  onError?: () => void;
}

export default function SpeedImage({
  imagePosition,
  baseUrl,
  extension,
  sourceWidth,
  viewportWidth,
  viewportHeight,
  onLoad,
  onError,
}: Props) {
  // Null source width falls through to every tier (legacy meta).
  const showMedium =
    sourceWidth == null || sourceWidth >= MIN_SOURCE_WIDTH.medium;
  const showHigh = sourceWidth == null || sourceWidth >= MIN_SOURCE_WIDTH.high;

  return (
    <>
      <ImageLayer
        quality="low"
        imagePosition={imagePosition}
        baseUrl={baseUrl}
        extension={extension}
        viewportWidth={viewportWidth}
        viewportHeight={viewportHeight}
        onLoad={onLoad}
        onError={onError}
      />
      {showMedium && (
        <ImageLayer
          quality="medium"
          imagePosition={imagePosition}
          baseUrl={baseUrl}
          extension={extension}
          viewportWidth={viewportWidth}
          viewportHeight={viewportHeight}
        />
      )}
      {showHigh && (
        <ImageLayer
          quality="high"
          imagePosition={imagePosition}
          baseUrl={baseUrl}
          extension={extension}
          viewportWidth={viewportWidth}
          viewportHeight={viewportHeight}
        />
      )}
    </>
  );
}
